(function () {
    "use strict";

    // @ngInject
    function DriftServiceCtor(AppStates, DeviceService, Drift, $window, $state, AnalyticsService, AppConfigService) {
        this.Drift = Drift;
        this.$window = $window;
        this.$state = $state;
        this.AnalyticsService = AnalyticsService;
        this.AppConfigService = AppConfigService;


        this.isMobile = DeviceService.nxSmallBreakpoint();
        this.isInAppBrowser = DeviceService.isInAppBrowser();
        this.didTrackDriftMessage = false;

        this.isTurnedOn = false;
        this.shouldTurnOn = false;


        if (this.isInAppBrowser) {
            this.Drift.hide();
        }

        if (this.isMobile) {
            //for mobile
            this.disallowedStates = {
                partialMatch: [ //disallowed states will include all underlying states as well
                    AppStates.root_network,
                    AppStates.root_core_workspaceFile,
                    AppStates.root_core_onboardingMobileQuiz,
                ],
                exactMatch: [
                    AppStates.root_core_navigation_onboardingSetupGuide,
                    AppStates.root_core_navigation_templatesEditor,
                ]
            };
        } else {
            //for desktop
            this.disallowedStates = {
                partialMatch: [
                    {
                        state: AppStates.root_core_workspaceFile,
                        params: {isOnboardingInvoiceMode: true} //state will be disallowed when combined with this parameter
                    }
                ],
                exactMatch: [
                    AppStates.root_core_onboardingInvoiceCreationStart,
                    AppStates.root_core_onboardingInvoiceCreationBrand,
                    AppStates.root_core_onboardingInvoiceCreationPackage,
                    AppStates.root_core_onboardingInvoiceCreationEmail,
                    AppStates.root_core_navigation_onboardingSetupGuide,
                    AppStates.root_core_onboardingInvoiceV2CreationStart,
                    AppStates.root_core_onboardingInvoiceV2CreationBrand,
                    AppStates.root_core_onboardingInvoiceV2CreationPackage,
                ]
            };
        }

        this.registerForDriftEvents();
    }

    Services.DriftService = Class(function () {
        return {

            constructor: DriftServiceCtor,

            isParamsMatch: function isParamsMatch(stateParams, paramsToMatch) {
                if (stateParams && paramsToMatch) {
                    var keys = Object.keys(paramsToMatch);
                    for (var i=0; i<keys.length; i++) { //check every condition if there's a match. We need to match ALL params
                        var key = keys[i];
                        var expValue = paramsToMatch[key];
                        if (expValue === true && !stateParams[key]) { //expected value is true, but param does not exist
                            return false; //no param match
                        } else if (!expValue && !!stateParams[key]) { //expected value is null, undefined, or false, but param exists
                            return false; //no param match
                        } else if (expValue && expValue !== true && expValue !== stateParams[key]) { //no exact match between expected value and real param
                            return false; //no param match
                        }
                    }
                    return true;
                }

                return false;
            },

            isStateAllowed: function isStateAllowed(state, params) {
                var i, entry;
                for (i = 0; i < this.disallowedStates.partialMatch.length; i++) {
                    entry = this.disallowedStates.partialMatch[i];
                    if (typeof entry === 'string') {
                        if (state.name.startsWith(entry)) {
                            return false;
                        }
                    } else if (typeof entry === 'object') {
                        if (state.name.startsWith(entry.state) && this.isParamsMatch(params, entry.params)) {
                            return false;
                        }
                    }
                }
                for (i = 0; i < this.disallowedStates.exactMatch.length; i++) {
                    entry = this.disallowedStates.exactMatch[i];
                    if (typeof entry === 'string') {
                        if (state.name === entry) {
                            return false;
                        }
                    } else if (typeof entry === 'object') {
                        if (state.name === entry.state && this.isParamsMatch(params, entry.params)) {
                            return false;
                        }
                    }
                }

                return true;
            },

            onStateChange: function onStateChange(fromState, toState, toParams, currUser) {
                if (currUser && currUser.company && currUser.company.subscribed) { //company now subscribed - don't show drift
                    this.Drift.hide();
                    return;
                }

                if (this.isStateAllowed(toState, toParams)) {
                    if (!this.isTurnedOn && this.shouldTurnOn) {
                        this.turnOnDrift(currUser, true);
                    }
                    this.Drift.show();
                } else {
                    this.Drift.hide();
                }
            },

            handleCurrentState: function handleCurrentState(currUser) {
                this.onStateChange(null, this.$state.current, this.$state.params, currUser);
            },

            restoreDefaultVisibility: function restoreDefaultVisibility() {
                this.handleCurrentState(null);
            },

            turnOnDrift: function turnOnDrift(currUser, skipStateCheck) {
                if (this.AppConfigService.isTest() || this.AppConfigService.isE2E())  {
                    return;
                }

                this.shouldTurnOn = true;

                if (!currUser) {
                    return;
                }
                if (skipStateCheck || (this.$state && this.$state.current && this.isStateAllowed(this.$state.current, this.$state.params))) {
                    var currCompany = currUser.company;
                    var Drift = this.Drift;


                    if (currUser.company &&
                        currUser.has_trial &&
                        !currUser.companyHasSubscription()) {

                        if (!this.$window.drift) {
                            Drift.instantiate();
                            Drift.configure();

                            setTimeout(function () {
                                Drift.identify(currUser, currCompany);
                                Drift.update(currUser, currCompany);
                                this.handleCurrentState(currUser);
                            }.bind(this), (currUser.notFirstSession() ? 1000 : 80000));

                        } else {
                            this.handleCurrentState(currUser);
                        }
                        this.isTurnedOn = true;
                    }
                }
            },

            turnOffDrift: function turnOffDrift(currUser) {
                this.Drift.hide();
                if (currUser.company) {
                    currUser.company.off('success', this._handleCompanySuccessForDrift);
                }
            },

            _handleCompanySuccessForDrift: function _handleCompanySuccessForDrift(currCompany) {
                if (!currCompany.subscribed) {
                    this.Drift.show();
                } else {
                    this.Drift.hide();
                }
            },

            trackDriftMessage: function trackDriftMessage() {
                if (!this.didTrackDriftMessage) {
                    this.AnalyticsService.track(this, "drift conversation started", {is_mobile: this.isMobile}); //We call it "drift conversation started" because it is sent only once per session
                    this.didTrackDriftMessage = true;
                }
            },

            registerForDriftEvents: function registerForDriftEvents() {
                this.Drift.registerCallback("startConversation", this.trackDriftMessage.bind(this));
                this.Drift.registerCallback("message:sent", this.trackDriftMessage.bind(this));
            }

        };
    });
}());
